import React, { useState, useEffect } from "react";
import DoctorsStepper from "./DoctorsStepper";
import { useOutletContext } from "react-router-dom";

function DoctorsAdd() {
  const [activeStep, setActiveStep] = useState(0);

    const outletContext = useOutletContext();

const setPageTitle = outletContext?.setPageTitle || (() => {});



 useEffect(() => {
        setPageTitle("Add Doctor Details");
    }, [])

  return (
    <div>
      <main style={{ width: "100%", height: "100%", padding: "1rem" }}>
        {/* <div className="row">
          <div className="col-12">
            <h3 className="fw-bold h3-tFkjpOnsnt" style={{ color: "#000" }}>
              Add Doctor Details
            </h3>
          </div>
        </div> */}

        <div className="row">


          <DoctorsStepper  steps={2} activeStep={activeStep} setActiveStep={setActiveStep}/>
        </div>
      </main>
    </div>
  );
}

export default DoctorsAdd;
